import React from "react"
import { useStaticQuery, graphql } from "gatsby"
import Image from "./image"

const randomGenerator = (min, max) => {
  return Math.floor(Math.random() * (max - min + 1)) + min
}

const FrontPageBillboard = () => {
  const data = useStaticQuery(graphql`
    query {
      allMdx(filter: {frontmatter: {randomable: {eq: true}}}) {
        nodes {
          id
          slug
          image {
            id
            key
            maxSize
            size
            srcSet
            srcPath
            width
            height
            sqSrcSet
            srcSet
          }
        }
      }
    }
  `)
  const randomPosition = Math.floor(Date.now() / 100000) % (data.allMdx.nodes.length - 1);

  return <Image slug={data.allMdx.nodes[randomPosition].slug} image={data.allMdx.nodes[randomPosition].image} />
}

export default FrontPageBillboard 